function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 1,
  width: 14,
  height: 18,
  rx: 2,
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 5H4",
  stroke: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2 15H4",
  stroke: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2 13H4",
  stroke: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2 7H4",
  stroke: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 14V11.75M6.75 11.75V6C6.75 6 9 7 9 11.75H6.75Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13 6V9.41667M13 14V9.41667M13 9.41667H12.5C11.9477 9.41667 11.5 8.96895 11.5 8.41667V6M13 9.41667H13.5C14.0523 9.41667 14.5 8.96895 14.5 8.41667V6",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.629cde68.svg";
export { ForwardRef as ReactComponent };